export enum AppProfileOptions {
  openam = 'openam',
  standard = 'standard',
  ldap = 'ldap',
}
